import { render } from "./NavbarFive.vue?vue&type=template&id=6519d1e7&scoped=true&ts=true"
import script from "./NavbarFive.vue?vue&type=script&lang=ts"
export * from "./NavbarFive.vue?vue&type=script&lang=ts"

import "./NavbarFive.vue?vue&type=style&index=0&id=6519d1e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6519d1e7"]])

export default __exports__